import { useMetaApiMutation } from '../features/metaApiSlice';
import { v4 as uuidv4 } from 'uuid';
import { getValidFbParam } from '../utils';
import { isClassmedMode } from '../utils/classmed';

const useMeta = () => {
  const [metaApi] = useMetaApiMutation();

  const metaEvent = async (event_name) => {
    if (isClassmedMode()) return null;

    try {
      await window?.clientParamBuilder?.processAndCollectAllParams();
      const id = uuidv4();
      const email = localStorage.getItem('email');
      const external_id = sessionStorage.getItem('externalId');
      const fbp = getValidFbParam(window?.clientParamBuilder?.getFbp());
      const fbc = getValidFbParam(window?.clientParamBuilder?.getFbc());
      if (window.fbq) {
        window.fbq(
          'track',
          event_name,
          {},
          {
            eventID: id,
          },
        );
      }
      const event_source_url = window.location.origin + window.location.pathname;
      return metaApi({
        event_name,
        id,
        email,
        page: window.location.href,
        external_id,
        fbp,
        fbc,
        currency: 'EUR',
        event_source_url,
      })
        .unwrap()
        .catch((error) => console.log('meta error =>', error));
    } catch (error) {
      console.log('meta error =>', error);
    }
  };
  return { metaEvent };
};

export default useMeta;
